import { Flex, IconButton, IconName, Tooltip } from '@aloft/toolkit-sui';

import { clsx } from 'clsx';

type Props = {
  id?: string;
  label: string;
  icon: IconName;
  isSelected: boolean;
  onClick: () => void;
};

export function ReferenceTab({ id, label, icon, isSelected, onClick }: Props) {
  const classes = ['reference-tab'];
  if (isSelected) classes.push('selected');

  return (
    <Flex className={clsx(classes)} width="100%" alignItems="center" justifyContent="center">
      <Tooltip label={label} placement="left">
        <IconButton
          id={id}
          ariaLabel={label}
          icon={icon}
          iconColor={isSelected ? 'surfaceAccent4' : 'textTertiary'}
          iconSize="lg"
          onClick={onClick}
          variant="tertiary"
          size="md"
        />
      </Tooltip>
    </Flex>
  );
}
